
export const BACKEND_URL = 'https://bjrpg.gdainti.com' //process.env.REACT_APP_BACKEND_URL;
// for local debugging:
// export const BACKEND_URL = 'http://localhost:8080';

export enum DefaultEnums {
  DEFAULT_HP = 10,
  DEFAULT_ATTACK = 2,
  DEFAULT_DEFENCE = 1,
  DEFAULT_PIERCE = 0,
  HEALTH_POTION_PER_CHEST = 5,
  GOLD_PER_CHEST = 10,
  DEFAULT_POTIONS = 10,
  HEAL_AMOUNT = 30,
  DEFAULT_BALANCE = 100,
  NUMBER_OF_STAGES = 4,
  HEALTH_POTION_PER_BJ = 2,
  HEALTH_POTION_PER_SIDEWIN = 1,
  DEFAULT_PENETRATION_MODIFIER = 2,
  DEFAULT_BET = 1,
  DEFAULT_TIMEOUT = 1000,
  DEFAULT_TIMETRACKING_TIMEOUT = 300000
}

export enum AchivementConditions {
  KILLED = 'k',
  KILLED_BY = 'kb',
  BEATEN = 'b',
  REACHED = 'r',
  AVERAGE = 'a',
  USED = 'u',
  GIVEN = 'g',
  TAKEN = 't'
}

export enum GamePlayState {
  VOID = 'VOID',
  GAME_START = 'GAME_START',
  STORY_INTRO = 'STORY_INTRO',
  CHARACTER_SELECTION = 'CHARACTER_SELECTION',
  STORY_OUTRO = 'STORY_OUTRO',
  BETTING = 'BETTING',
  PLAYER_CARD_REVEAL = 'PLAYER_CARD_REVEAL',
  PLAYER_ACTION = 'PLAYER_ACTION',
  DEALER_CARD_REVEAL = 'DEALER_CARD_REVEAL',
  VICTORY = 'VICTORY',
  DEFEAT = 'DEFEAT'
}